import { StateVariable } from '@akin-home/state-variables';
import {
  GetStateVariableParams,
  getStateVariables,
} from '@akin-home/state-variables-frontend';
import { UseQueryResult, useQuery } from 'react-query';

export const useGetStateVariable = (
  params: GetStateVariableParams,
  options?: any
): UseQueryResult<StateVariable | undefined, unknown> => {
  const { username, application_id, name } = params;

  return useQuery(
    ['state_variables', 'detail', username, application_id, name],
    () => getStateVariables({ username, application_id, names: [name] }),
    {
      ...options,
      select(data) {
        return data?.[0];
      },
    }
  );
};
